import { render } from "./show.vue?vue&type=template&id=7309d23a&scoped=true"
import script from "./show.vue?vue&type=script&lang=js"
export * from "./show.vue?vue&type=script&lang=js"

import "./show.vue?vue&type=style&index=0&id=7309d23a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7309d23a"]])

export default __exports__